export default __webpack_public_path__ + "static/media/add.8267cb56.svg";